import { NATIVE_FLAG, type NaumuDesktopBridge } from './bridge';

/**
 * Bridge object the React Native WebView injects on `window` for the web→native
 * direction. Present ONLY when the app runs inside the native shell; `undefined`
 * in every normal browser.
 */
interface ReactNativeWebView {
	postMessage: (message: string) => void;
}

declare global {
	interface Window {
		ReactNativeWebView?: ReactNativeWebView;
		/**
		 * Bridge the Electron desktop shell injects (via `contextBridge`) for the
		 * web→native direction. Present ONLY inside the desktop shell.
		 */
		naumuDesktop?: NaumuDesktopBridge;
		/** Injected by the native shell before content loads; see NATIVE_FLAG. */
		[NATIVE_FLAG]?: boolean;
	}
}

/**
 * True only when running inside a Naumu native shell — the React Native WebView
 * wrapper (apps/mobile) OR the Electron desktop wrapper (apps/desktop). Both set
 * `window.__NAUMU_NATIVE__ === true` before the page loads. Everything the shim
 * does gates on this so it is a strict no-op in a normal browser.
 */
export const isNativeShell = (): boolean => {
	if (typeof window === 'undefined') return false;
	return window[NATIVE_FLAG] === true;
};

/**
 * True only when running inside the Electron desktop shell, which injects
 * `window.naumuDesktop` via `contextBridge`. Detection uses the injected global,
 * never the user agent. `undefined` in the RN WebView and in a normal browser.
 */
export const isDesktopShell = (): boolean => {
	if (typeof window === 'undefined') return false;
	return window.naumuDesktop != null;
};
